import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector:    'app-affiliate-detail',
  templateUrl: './affiliate-detail.component.html',
  styles:      [],
})
export class AffiliateDetailComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
